import React from 'react';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import { inMiniProgram } from '../../utils/WeChatUtil';
import { SHOW_HOME_SIGNUP } from '../../utils/Config';
import { detectIsMobileByScreenWidth } from '../../utils/ScreenUtils';
import i18n from '../../utils/I18n';
import { openLoginPage } from '../../utils/SSOUtil';
import './SignUpBanner.scss';


const SignUpBanner = ({
  isLogin,
  isOpenInOtherSite,
}) => {
  const isInMiniProgram = inMiniProgram();
  const isMobileScreen = detectIsMobileByScreenWidth();

  const loginButtonDidClicked = () => {
    openLoginPage({
      locale: i18n?.language || 'en',
    });
  };

  if (isLogin || isInMiniProgram || isOpenInOtherSite) {
    return null;
  };

  return (
    <div
      className={`home_login_banner ${SHOW_HOME_SIGNUP ? '' : 'hidden'}`}
    >
      <Container className={`home_container ${isMobileScreen ? "" : "web_sign_up_banner"}`}>
        <div className='home_signup_title'>
          <span className='headline'>
            {i18n.t('home_hello')}
          </span>
          <span className='home_signup_second tag-menu-1'>
            {i18n.t('home_signup_text')}
          </span>
        </div>
        <div
          className="nav_btn signup button-large"
          onClick={loginButtonDidClicked}
        >
          {i18n.t('sign_up_login')}
        </div>
      </Container>
    </div>
  )
}

const mapStateToProps = (state) => ({
  isLogin: state.users.isLogin,
  isOpenInOtherSite: state.users.isOpenInOtherSite,
});

export default connect(mapStateToProps)(SignUpBanner);
